import {
    Box,
    Tab,
    Tabs,
    darken
} from "@mui/material";
import {
    Page,
    usePageNavigation
} from "../contexts/PageNavigationContextProvider";
import {
    useRef,
    useState
} from "react";

import { ContactUs } from "../ContactUs";
import { IssueDashboardTable } from "../IssueDashboardTable";
import { ListIssuesPage } from "./ListIssuesPage";
import { ListIssuesTable } from "./ListIssuesTable";
import { ManageSchedules } from "../../assessmentSchedule/ManageSchedules";
import { Property } from "../../../API";
import { PropertyStatistics } from "../PropertyStatistics";
import { ShareButton } from "../ShareButton";
import { useAssessments } from "../contexts/AssessmentsContextProvider";
import { useContacts } from "../contexts/ContactContextProvider";

export type PropertyPageProps = {
    property: Property;
};

enum TabEnum {
    ISSUE = "ISSUE",
    SCHEDULE = "SCHEDULE",
    PROPERTY = "PROPERTY"
}

export const PropertyPage = (props: PropertyPageProps) => {
    const { property } = props;
    const { assessmentSchedules,
        fetchAssessmentScheduleStatus,
        assessmentScheduleIdToResourceIdsMap,
    } = useAssessments();
    const pageNavigationContext = usePageNavigation();


    const [tabIndex, setTabIndex] = useState(TabEnum.ISSUE);
    const printComponentRef = useRef(null);
    const { contacts, setIsOpenCreateContactDialog } = useContacts();

    const showScheduleTab = (
        fetchAssessmentScheduleStatus &&
        assessmentScheduleIdToResourceIdsMap &&
        assessmentSchedules
    );

    return (
        <Box px={{ md: 2, lg: 6 }}>
            <Box display="flex" flexDirection="column" gap={2}>
                <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                    <Box display="flex" flexDirection="row" ml="auto">
                        <ShareButton
                            linkMessage={`Check out ${property.name} on our website`}
                        />
                    </Box>
                </Box>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={tabIndex}
                        variant="fullWidth"
                        onChange={(event, newValue) => setTabIndex(newValue)}
                        sx={{
                            '& .MuiTab-root': {
                                flex: 1,
                                textAlign: 'center',
                                backgroundColor: '#374957',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: darken('#374957', 0.2),
                                },
                            },
                            '& .Mui-selected': {
                                backgroundColor: '#F8B42A',
                                // For some reason, backgroundColor overrides color unless !important is used
                                pointerEvents: 'none',
                                color: 'white !important',
                                '&:hover': {
                                    backgroundColor: '#F8B42A',
                                },
                            },
                            '& .MuiTabs-flexContainer': {
                                justifyContent: 'space-between',
                                gap: "0.25rem"
                            },
                        }}
                    >
                        <Tab value={TabEnum.ISSUE} label="Issues" />
                        {showScheduleTab && <Tab value={TabEnum.SCHEDULE} label="Schedules" />}
                        <Tab value={TabEnum.PROPERTY} label="Property" />
                    </Tabs>
                </Box>
                {
                    tabIndex === TabEnum.ISSUE &&
                    <Box ref={printComponentRef}>
                        {(() => {
                            switch (pageNavigationContext.currentPage) {
                                case Page.Issues:
                                    return <ListIssuesPage />;
                                case Page.Table:
                                    return <ListIssuesTable />;
                                default:
                                    return <IssueDashboardTable />;
                            }
                        })()}
                    </Box>
                }
                {
                    tabIndex === TabEnum.PROPERTY &&
                    <Box ref={printComponentRef}>
                        <PropertyStatistics
                            property={property}
                        />
                    </Box>
                }
                {
                    tabIndex === TabEnum.SCHEDULE && showScheduleTab &&
                    <Box ref={printComponentRef}>
                        <ManageSchedules
                            contacts={contacts!}
                            setIsOpenCreateContactDialog={setIsOpenCreateContactDialog!}
                        />
                    </Box>
                }
                <Box display="flex">
                    <ContactUs />
                </Box>
            </Box>
        </Box>
    );
};